import { request } from "../../api/api"
export const addAiModel =(data)=>{
    return request.post("/add-ai-model/",data)
}
export const getAiModel =(params)=>{
    return request.get(`/get-ai-models-admin-panel/?page=${params.llmPage}&page_size=${params.llmPageSize}`)
}
export const deleteAiModel =(id)=>{
    return request.delete(`/delete-ai-model/${id}/`)
}
export const updateAiModel =(id,data)=>{
    return request.put(`/update-ai-model/${id}/`, data)
}

